<template>
	<router-link :to="{name: 'user', params: {id: user.id}}">
		<a-tooltip v-if="tooltip" :placement="tooltip">
			<template #title>
				<span>{{ user.username }}</span>
			</template>
			<a-avatar :src="avatarSrc" :shape="shape" :size="size" @error="useFallback">
				<template #icon>
					<a-icon type="user" />
				</template>
			</a-avatar>
		</a-tooltip>
		<a-avatar v-else :src="avatarSrc" :shape="shape" :size="size" @error="useFallback" />
	</router-link>
</template>

<script>
const placeholder = require('../../../assets/img/placeholder/avatar.jpg');

export default {
	name: 'UserAvatar',
	props: {
		user: {
			type: Object,
			required: true,
		},
		size: {
			type: Number,
			default: 64,
		},
		shape: {
			type: String,
			default: 'square',
		},
		tooltip: {
			type: [Boolean, String],
			default: 'top',
		},
	},
	data() {
		return { broken: false };
	},
	computed: {
		avatarSrc() {
			return this.broken ? placeholder : this.images().avatar(this.user);
		},
	},
	watch: {
		user() { this.broken = false; },
	},
	methods: {
		useFallback() { this.broken = true; return false; },
	},
};
</script>

<style lang="scss" scoped>

</style>
